import React, { useState, useEffect } from "react";
import SeatMap from "./Seatmap"; // FlightReview wali me: "../AirResponse/Seatmap"
import { BaggageOffcanvas, MealOffcanvas } from "./FlightAddon";

const AGENCY_KEY = "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A";

export default function AddonManager({
  contractId,
  apiToken,
  bookingKey,
  returnContractId = null,
  isInternational = false,
  isB2C = false,
  grossPrice = 0,
  discount = 0,
  passengerCount = 1,
  adultCount = 0,
  childCount = 0,
  inrToAed = null,
  onAddonTotalChange,
  onSeatPriceChange,
  onMealPriceChange,
  onBaggagePriceChange,
  onSeatSelectionChange,
  onMealSelectionChange,
  onBaggageSelectionChange,
  openPanel: externalOpenPanel = null,
  onPanelChange,
  showInternalButtons = false,
  useDummy = false,
}) {
  const [openPanel, setOpenPanel] = useState(null);

  useEffect(() => {
    if (externalOpenPanel !== openPanel) {
      setOpenPanel(externalOpenPanel);
    }
  }, [externalOpenPanel]);

  const handlePanelChange = (panel) => {
    setOpenPanel(panel);
    if (onPanelChange) onPanelChange(panel);
  };

  const [ssrData, setSsrData] = useState(null);
  const [ssrLoading, setSsrLoading] = useState(false);
  const [ssrError, setSsrError] = useState(null);

  useEffect(() => {
    if (useDummy) return;
    if (!contractId) {
      setSsrError("Missing contract details");
      return;
    }
    if (ssrData) return;

    setSsrLoading(true);
    setSsrError(null);

    fetch("https://api.livev1.fly24hrs.com/api/Trip/SSR", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        APIToken: apiToken || "",
        AgencyKey: AGENCY_KEY,
        BookingKey: bookingKey || "",
        ContractId: String(contractId || ""),
        IsB2B: false,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        console.log("SSR Response:", data);
        if (data?.Status === 1) {
          setSsrData(data);
        } else {
          setSsrError(data?.Error?.ErrorDesc || "Failed to load addon data");
        }
        setSsrLoading(false);
      })
      .catch((err) => {
        console.error("❌ SSR fetch failed:", err);
        setSsrError("Failed to load addon data");
        setSsrLoading(false);
      });
  }, [contractId, apiToken, bookingKey, useDummy, ssrData]);

  // ---------- Persisted addon state (booking/contract-specific) ----------
  const [seatPrice, setSeatPrice] = useState(0);
const [baggagePrice, setBaggagePrice] = useState(0);
const [mealPrice, setMealPrice] = useState(0);
const [selectedSeatsList, setSelectedSeatsList] = useState([]);
const [mealSelectionMap, setMealSelectionMap] = useState({});
const [baggageSelectionMap, setBaggageSelectionMap] = useState({});

  // ek helper jo hamesha poora object save kare taaki keys overwrite na ho
  
  const combinedTotal = seatPrice + baggagePrice + mealPrice;
  const youPay = grossPrice - discount + combinedTotal;

  useEffect(() => {
    const setEl = (id, text) => { const el = document.getElementById(id); if (el) el.textContent = text; };
    const setVal = (id, val) => { const el = document.getElementById(id); if (el) el.value = val; };
    setEl("combinedTotalPrice", `Rs. ${combinedTotal}`);
    setVal("GrossPrice", youPay.toFixed(1));
    const payEl = document.querySelector(".pay_total span:last-child");
    if (payEl) payEl.textContent = `Rs.${youPay.toFixed(1)}`;
    if (window.$) {
      const upd = (label, price) =>
        window.$(`.price_detail:contains("${label}") .price`).text(
          price > 0 ? `Rs. ${price.toFixed(1)}` : "Rs. 0.00"
        );
      upd("Seat", seatPrice);
      upd("Meal", mealPrice);
      upd("Baggage", baggagePrice);
    }
    if (onAddonTotalChange) onAddonTotalChange(combinedTotal);
    if (onSeatPriceChange) onSeatPriceChange(seatPrice);
    if (onMealPriceChange) onMealPriceChange(mealPrice);
    if (onBaggagePriceChange) onBaggagePriceChange(baggagePrice);
  }, [seatPrice, baggagePrice, mealPrice, combinedTotal, youPay]);

  // SeatMap onDone => (seats[], totalPrice)
  const handleSeatDone = (seats, totalPrice) => {
    const p = parseFloat(totalPrice) || 0;
    setSeatPrice(p);
    setSelectedSeatsList(seats || []);
  
    if (onSeatSelectionChange) onSeatSelectionChange(seats || []);
    handlePanelChange(null);
  };

  // BaggageOffcanvas onDone => (totalPrice, selectionMap)
  const handleBaggageDone = (totalPrice, selectionMap) => {
    const p = parseFloat(totalPrice) || 0;
    setBaggagePrice(p);
    setBaggageSelectionMap(selectionMap || {});
 
    if (onBaggageSelectionChange) onBaggageSelectionChange(selectionMap || {});
    handlePanelChange(null);
  };

  // MealOffcanvas onDone => (totalPrice, selectionMap)
  const handleMealDone = (totalPrice, selectionMap) => {
    const p = parseFloat(totalPrice) || 0;
    setMealPrice(p);
    setMealSelectionMap(selectionMap || {});
   
    if (onMealSelectionChange) onMealSelectionChange(selectionMap || {});
    handlePanelChange(null);
  };

  return (
    <>
      {showInternalButtons && (
        <div className="view_box">
          <div className="flight_preview">
            <div className="flight_preview_head justify-content-start">
              <div className="addon_link" onClick={() => handlePanelChange("seat")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_seat"></span>Seat Selection
              </div>
              <div className="addon_link" onClick={() => handlePanelChange("meal")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_meal"></span>Add Meals
              </div>
              <div className="addon_link" onClick={() => handlePanelChange("baggage")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_baggage"></span>Add Baggage
              </div>
            </div>
          </div>
        </div>
      )}

      {openPanel && (
        <div
          onClick={() => handlePanelChange(null)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1050 }}
        />
      )}

      {openPanel === "seat" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "1100px", maxWidth: "98vw" }}>
            <SeatMap
              returnContractId={returnContractId}
              isB2C={isB2C}
              useDummy={useDummy}
              maxSeats={passengerCount}
              inrToAed={inrToAed}
              ssrData={ssrData}
              ssrLoading={ssrLoading}
              ssrError={ssrError}
              initialSelectedSeats={selectedSeatsList}
              onDone={handleSeatDone}
               onClose={() => handlePanelChange(null)}
            />
          </div>
        </div>
      )}

      {openPanel === "baggage" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "520px", maxWidth: "96vw" }}>
            <BaggageOffcanvas
              isInternational={isInternational}
              adultCount={adultCount}
              childCount={childCount}
              inrToAed={inrToAed}
              ssrData={ssrData}
              ssrLoading={ssrLoading}
              ssrError={ssrError}
              initialSelections={baggageSelectionMap}
              onDone={handleBaggageDone}
              onClose={() => handlePanelChange(null)}

            />
          </div>
        </div>
      )}

      {openPanel === "meal" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "520px", maxWidth: "96vw" }}>
            <MealOffcanvas
              adultCount={adultCount}
              childCount={childCount}
              inrToAed={inrToAed}
              ssrData={ssrData}
              ssrLoading={ssrLoading}
              ssrError={ssrError}
              initialSelections={mealSelectionMap}
              onDone={handleMealDone}
              onClose={() => handlePanelChange(null)}
            />
          </div>
        </div>
      )}
    </>
  );
}